import React from 'react';

export const LeftPageIcon = () => (
    <svg width="4" height="8" viewBox="0 0 4 8" fill="inherit" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.88284 0.130175C4.03905 0.303741 4.03905 0.585148 3.88284 0.758714L0.965685 4L3.88284 7.24129C4.03905 7.41485 4.03905 7.69626 3.88284 7.86983C3.72663 8.04339 3.47337 8.04339 3.31716 7.86983L0.117157 4.31427C-0.0390524 4.1407 -0.0390524 3.8593 0.117157 3.68573L3.31716 0.130175C3.47337 -0.0433916 3.72663 -0.0433916 3.88284 0.130175Z" fill="inherit"/>
    </svg>
);
